import { tokenAxios } from "@/utils/axios";
import { useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Filter } from "@/types/order-table";
import { useAppState } from "@/contexts/app-state";
import { useOrdersContext } from "@contexts/orders-context";
import { checkSearchKeyMinCharCount } from "@/utils/helpers";
import { buildApiUrl } from "@/utils/api";

interface GetFiltersArgs {
  user: string;
  type: Filter;
  searchString: string;
  departmentId: string;
  bucketName?: string;
  practiceId: string;
}

const getFiltersWithSearchString = async (params: GetFiltersArgs) => {
  const { data } = await tokenAxios().get<string[]>(buildApiUrl(`filters/${params.type}/searchString`), {
    params,
  });
  return data;
};

export const useFiltersWithSearchString = (type: Filter, searchString: string) => {
  const { loggedInUser, context, currentUser } = useAppState();
  const { filters } = useOrdersContext();
  const location = useLocation();
  const bucketName = location.pathname === "/admin" && currentUser
  || location.pathname === "/user-activity" ? currentUser : undefined;

  return useQuery<string[], Error>({
    queryKey: ["filtersWithSearchString", { user: loggedInUser, type, searchString, bucketName, filters }],
    queryFn: () =>
      getFiltersWithSearchString({
        user: loggedInUser,
        type,
        searchString,
        departmentId: context?.athena?.departmentId || "3089",
        bucketName: bucketName || "ALL",
        practiceId: context?.athena?.practiceId || "8967",
      }),
      enabled: checkSearchKeyMinCharCount(type, searchString),
  });
};
